import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d32240ec&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
import style0 from "./Error.vue?vue&type=style&index=0&id=d32240ec&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32240ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d32240ec')) {
      api.createRecord('d32240ec', component.options)
    } else {
      api.reload('d32240ec', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=d32240ec&scoped=true", function () {
      api.rerender('d32240ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Error.vue"
export default component.exports